import clarity from "@microsoft/clarity";

type ClarityConfig = {
  projectId: string;
};

let initialized = false;

export function initializeClarity(config: ClarityConfig) {
  if (initialized) {
    return;
  }

  clarity.init(config.projectId);
  initialized = true;
}

export function identifyUser(userId: string, sessionId?: string, pageId?: string, userHint?: string) {
  if (!initialized) {
    return;
  }

  clarity.identify(userId, sessionId, pageId, userHint);
}
